import { render, staticRenderFns } from "./BannerCountdown.vue?vue&type=template&id=0f43dbc5&scoped=true"
import script from "./BannerCountdown.vue?vue&type=script&lang=js"
export * from "./BannerCountdown.vue?vue&type=script&lang=js"
import style0 from "./BannerCountdown.vue?vue&type=style&index=0&id=0f43dbc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43dbc5",
  null
  
)

export default component.exports